var exports = {
  "k": "container__yQtlG9",
};

module.exports = exports;
